const prefArea = {
  '北海道':'hokkaido',
  '青森県':'kitatohoku',
  '岩手県':'kitatohoku',
  '宮城県':'minamitohoku',
  '秋田県':'kitatohoku',
  '山形県':'minamitohoku',
  '福島県':'minamitohoku',
  '茨城県':'kanto',
  '栃木県':'kanto',
  '群馬県':'kanto',
  '埼玉県':'kanto',
  '千葉県':'kanto',
  '東京都':'kanto',
  '神奈川県':'kanto',
  '新潟県':'chubu',
  '富山県':'chubu',
  '石川県':'chubu',
  '福井県':'chubu',
  '山梨県':'chubu',
  '長野県':'chubu',
  '岐阜県':'chubu',
  '静岡県':'chubu',
  '愛知県':'chubu',
  '三重県':'kinki',
  '滋賀県':'kinki',
  '京都府':'kinki',
  '大阪府':'kinki',
  '兵庫県':'kinki',
  '奈良県':'kinki',
  '和歌山県':'kinki',
  '鳥取県':'chugoku',
  '島根県':'chugoku',
  '岡山県':'chugoku',
  '広島県':'chugoku',
  '山口県':'chugoku',
  '徳島県':'shikoku',
  '香川県':'shikoku',
  '愛媛県':'shikoku',
  '高知県':'shikoku',
  '福岡県':'kyusyu',
  '佐賀県':'kyusyu',
  '長崎県':'kyusyu',
  '熊本県':'kyusyu',
  '大分県':'kyusyu',
  '宮崎県':'kyusyu',
  '鹿児島県':'kyusyu',
  '沖縄県':'okinawa',
};
  
function getPrefArea(pref) {
  return prefArea[pref];
}

$(function(){
  
  const getProductShortestDeliveryUrl = '/apps/mall/admin/product-shortestdelivery';
  // Helper to get base64-encoded customerId
  function getBase64CustomerId() {
    if (typeof customerId !== 'undefined' && customerId !== null) {
      return btoa(customerId);
    }
    return null;
  }

  async function fetchShortestDelivery(deliveryDays) {
    if (deliveryDays === undefined) {
      return;
    }
    try {
      let url = getProductShortestDeliveryUrl+'?deliveryDays='+deliveryDays;

      const base64CustomerId = getBase64CustomerId();
      if (base64CustomerId) url += `&v=${base64CustomerId}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const res = await response.json();
      //$('#shortestdelivery_date').html(res.deliveryDate.from);
      if (shortestExpressFlag) {
        shortestExpressDate = "-";
        if (res.expressDeliveryDate.from != "") {
          shortestExpressDate = res.expressDeliveryDate.from;
        }
        $('#shortestdelivery_date').html("通常便："+res.normalDeliveyDate.from+"<br>お急ぎ便："+shortestExpressDate);
      } else {
        $('#shortestdelivery_date').html("通常便："+res.normalDeliveyDate.from);
      }
      //$('#shortestdelivery_express_date').html("特急便："+res.expressDeliveryDate.from);
      $('#shortestdelivery_date_value').val(res.deliveryValue.from);
      $('#no_delivery_date_text').html(res.noDeliveryText);
    } catch (error) {
      //console.error('Error fetching shortestdelivery s:', error);
    }
  }

  async function fetchNormalDelivery(deliveryDays) {
    try {
      let url = getProductShortestDeliveryUrl+'?deliveryDays='+deliveryDays;
      const base64CustomerId = getBase64CustomerId();
      if (base64CustomerId) url += `&v=${base64CustomerId}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const res = await response.json();
      $('#normal-delivery-date').val(res.deliveryValue.from);
      $('#normal-delivery-date').attr('min', res.deliveryValue.from);
      $('#normal-delivery-date').attr('max', res.deliveryValue.to); 
      $('#normal-delivery-date').prop('disabled', false);
      $('#normal-delivery-time').prop('disabled', false);
      //$('#normal-delivery-date-message').find('li').html(res.deliveryValue.from+'から'+res.deliveryValue.to+'の間で選択してください');
      $('#normal-delivery-date-message').html('');
      $('#normal-delivery-date-message').append('<li>'+res.deliveryValue.from+'から'+res.deliveryValue.to+'の間で選択してください</li>');
      $('#normal-delivery-date-message').append('<li>選択ができない日は納品停止期間のためお届けができません </li>');
      $('#normal-delivery-date-message').show();

      flatpickr('#normal-delivery-date', {
        minDate: res.deliveryValue.from,
        maxDate: res.deliveryValue.to,
        locale: "ja",
        dateFormat: "Y-m-d",
        disable:[
          res.noDeliveyDate.arr,
          {
            from: res.noDeliveyDate.from,
            to: res.noDeliveyDate.to,
          }
        ]
      });
    } catch (error) {
      //console.error('Error fetching shortestdelivery s:', error);
    }
  }

  async function fetchCartShortestDelivery(deliveryDays) {
    try {
      let url = getProductShortestDeliveryUrl+'?deliveryDays='+deliveryDays;
      const base64CustomerId = getBase64CustomerId();
      if (base64CustomerId) url += `&v=${base64CustomerId}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const res = await response.json();
      $('#cart-delivery-date').val(res.deliveryValue.from);
      $('#cart-delivery-date').attr('min', res.deliveryValue.from);
      $('#cart-delivery-date').attr('max', res.deliveryValue.max);
      $('#cart-delivery-date').prop('disabled', false);
      $('#cart-delivery-time').prop('disabled', false);
      //$('#cart-delivery-date-message').find('li').html(res.deliveryValue.from+'から'+res.deliveryValue.to+'の間で選択してください');
      $('#cart-delivery-date-message').html('');
      $('#cart-delivery-date-message').append('<li>'+res.deliveryValue.from+'から'+res.deliveryValue.to+'の間で選択してください</li>');
      $('#cart-delivery-date-message').append('<li>選択ができない日は納品停止期間のためお届けができません </li>');
      $('#cart-delivery-date-message').show();

      let disabledDate = JSON.stringify(res.noDeliveyDate);
      
      flatpickr('#cart-delivery-date', {
        minDate: res.deliveryValue.from,
        maxDate: res.deliveryValue.to,
        locale: "ja",
        dateFormat: "Y-m-d",
        disable: JSON.parse(disabledDate)
      });    
    
    } catch (error) {
      //console.error('Error fetching shortestdelivery s:', error);
    }
  }

  async function fetchExpressShortestDelivery(deliveryDays) {
    try {
      let url = getProductShortestDeliveryUrl+'?express=1&deliveryDays='+deliveryDays;
      const base64CustomerId = getBase64CustomerId();
      if (base64CustomerId) url += `&v=${base64CustomerId}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const res = await response.json();

      if (!res.isExpressOK) {
        // お急ぎ便は不可
        $('#express-delivery-date-message').hide();
        $('#express-delivery-date-message-error').addClass('form__box__errortext');
        $('#express-delivery-date-message-error').show();
        $('#express-delivery-date').addClass("form__box__error");
        $('input[name="properties[STEP5_お急ぎ便希望日・時間_お届け希望日]"]').val('');
        flatpickr('#express-delivery-date', {
          locale: "ja",
          disable: [
            {
              from: "1900-04-01",
              to:"9999-04-01"
            }
          ]
        });
      } else {
        let disabledDate = JSON.stringify(res.noDeliveyDate);
        $('#express-delivery-date').removeClass("form__box__error");
        $('#express-delivery-date').val(res.deliveryValue.from);
        $('#express-delivery-date').attr('min', res.deliveryValue.from);
        $('#express-delivery-date').attr('max', res.deliveryValue.to); 
        $('#express-delivery-date').prop('disabled', false);
        $('#express-delivery-time').prop('disabled', false);
        $('#express-delivery-date-message').html('');
        $('#express-delivery-date-message').append('<li>'+res.deliveryValue.from+'から'+res.deliveryValue.to+'の間で選択してください</li>');
        $('#express-delivery-date-message').append('<li>選択ができない日は納品停止期間のためお届けができません </li>');
        $('#express-delivery-date-message').show();
        $('#express-delivery-date-message-error').hide();
        flatpickr('#express-delivery-date', {
          minDate: res.deliveryValue.from,
          maxDate: res.deliveryValue.to,
          locale: "ja",
          dateFormat: "Y-m-d",
          disable: JSON.parse(disabledDate)
        });        
      }
    
    } catch (error) {
      //console.error('Error fetching shortestdelivery s:', error);
    }
  }
  
  // 商品詳細
  if ($('#product-prefecture').length > 0) {
    // 対象都道府県の書き込み
    if (subjectPrefecture === undefined || subjectPrefecture == '') {
      let select = "<select id='product-prefecture-select'>";
      $.each(prefArea, function(key) {
        let selected = '';
        if (key == '東京都'){
          selected = 'selected';
        }
        select += '<option value="'+key+'" '+selected+'>'+key+'</option>';
      });
      select += '</select>';
      $('#product-prefecture').html(select);
    } else {
      let select = "<select id='product-prefecture-select'>";
      let selectFirstFlag = 0;
      $.each(subjectPrefecture, function(key) {
        let selected = '';
        if (key == '東京都'){
          selected = 'selected';
        }
        select += '<option value="'+key+'" '+selected+'>'+key+'</option>';
        selectFirstFlag = 1;
      });
      select += '</select>';
      $('#product-prefecture').html(select);
    }

    fetchShortestDelivery(shortestDelivery[getPrefArea($('#product-prefecture-select').val())]);
    $('#product-prefecture-select').change(function(){
      if ($(this).val() == '') return;
      fetchShortestDelivery(shortestDelivery[getPrefArea($(this).val())]);
    });
  }

  // MSAD用通常便
  if ($('#normal_prefecture').length > 0) {
    // 対象都道府県の書き込み
    if (subjectPrefecture === undefined || subjectPrefecture == '') {
      let select = "<select id='normal-prefecture-select' name='properties[STEP5_通常配送希望日・時間_都道府県]'>";
      select += '<option value="">選択してください</option>';
      $.each(prefArea, function(key) {
        let selected = '';
        // if (key == '東京都'){
        //   selected = 'selected';
        // }
        select += '<option value="'+key+'" '+selected+'>'+key+'</option>';
      });
      select += '</select>';
      $('#normal_prefecture').html(select);
    } else {
      let select = "<select id='normal-prefecture-select' name='properties[STEP5_通常配送希望日・時間_都道府県]'>";
      let selectFirstFlag = 0;
      select += '<option value="">選択してください</option>';
      $.each(subjectPrefecture, function(key) {
        let selected = '';
        // if (selectFirstFlag == 0){
        //   selected = 'selected';
        // }
        select += '<option value="'+key+'" '+selected+'>'+key+'</option>';
        selectFirstFlag = 1;
      });
      select += '</select>';
      $('#normal_prefecture').html(select);
    }

    fetchShortestDelivery(shortestDelivery[getPrefArea($('#normal-prefecture-select').val())]);
    $('#normal-prefecture-select').change(function(){
      if ($(this).val() == '') return;
      fetchNormalDelivery(shortestDelivery[getPrefArea($(this).val())]);
    });
  }

  // お急ぎ便
  if ($('#express_prefecture').length > 0) {
    // 対象都道府県の書き込み
    if (subjectPrefecture === undefined || subjectPrefecture == '') {
      let select = "<select id='express_prefecture_select' name='properties[STEP5_お急ぎ便希望日・時間_都道府県]'>";
      select += '<option value="">選択してください</option>';
      $.each(prefArea, function(key) {
        select += '<option value="'+key+'">'+key+'</option>';
      });
      select += '</select>';
      $('#express_prefecture').html(select);
    } else {
      let select = "<select id='express_prefecture_select' name='properties[STEP5_お急ぎ便希望日・時間_都道府県]'>";
      select += '<option value="">選択してください</option>';
      $.each(subjectPrefecture, function(key) {
        select += '<option value="'+key+'">'+key+'</option>';
      });
      select += '</select>';
      $('#express_prefecture').html(select);
    }
    //fetchExpressShortestDelivery(expressDelivery[getPrefArea($('#express_prefecture').val())]);
    $('#express_prefecture_select').change(function(){
      if ($(this).val() == '') return;
      fetchExpressShortestDelivery(expressDelivery[getPrefArea($(this).val())]);
    });
  }  

  
  // カート
  if ($('#cart-prefecture').length > 0) {
    // 配送可能地域のマージ
    // 論理積
    arrSubjectPref = [];
    $.each(arrSubjectPrefecture, function(index, row){
      arrSubjectPref[index] = [];
      if (row == "") {
        return true;
      }
      $.each(row, function(val){
        arrSubjectPref[index].push(val);
      });
    });

    let commonPref = [];

    // まず全都道府県をいれる
    arrSubjectPrefMaster = {"北海道":"1","青森県":"1","岩手県":"1","秋田県":"1","宮城県":"1","山形県":"1","福島県":"1","茨城県":"1","栃木県":"1","群馬県":"1","埼玉県":"1","千葉県":"1","東京都":"1","神奈川県":"1","新潟県":"1","富山県":"1","石川県":"1","福井県":"1","山梨県":"1","長野県":"1","岐阜県":"1","静岡県":"1","愛知県":"1","三重県":"1","滋賀県":"1","京都府":"1","大阪府":"1","兵庫県":"1","奈良県":"1","和歌山県":"1","鳥取県":"1","島根県":"1","岡山県":"1","広島県":"1","山口県":"1","徳島県":"1","香川県":"1","愛媛県":"1","高知県":"1","福岡県":"1","佐賀県":"1","長崎県":"1","熊本県":"1","大分県":"1","宮崎県":"1","鹿児島県":"1","沖縄県":"1"};
    $.each(arrSubjectPrefMaster, function(val){
      commonPref.push(val);
    });    

    $.each(arrSubjectPref, function(index, row){
      if (row === undefined || row == "") {
        return false;
      }
      commonPref = intersection(commonPref, row);
    });

    let cartSelect = '<select id="cart-prefecture-select" name="attributes[お届け希望日・時間_都道府県]" form="cart">';
    cartSelect += '<option value="">選択してください</option>';
    $.each(commonPref, function(index, val) {
      cartSelect += '<option value="'+val+'">' +val+'</option>';
    });
    cartSelect += '</select>';
    
    $('#cart-prefecture').html(cartSelect);

    $(document).on('change', '#cart-prefecture-select', function(){
    //$('#cart-prefecture').change(function(){
      if ($(this).val() == '') {
        $('#cart-delivery-date').prop('disabled', true);
        $('#cart-delivery-time').prop('disabled', true);
        return;
      }
      area = getPrefArea($(this).val());
      let deliveryDays = 0;
      $.each(arrCartShortestDelivery, function(index, row) {
        if (row === undefined) return true;
        if (Number(deliveryDays) < Number(row[area])) {
          deliveryDays = row[area];
        }
      });
      fetchCartShortestDelivery(deliveryDays);
    });
  }

  function intersection(first, second)
  {
      first = new Set(first);
      second = new Set(second);
      return [...first].filter(item => second.has(item));
  }
/*
  // 配送可能エリア
  if ($('.product__deliveryarea__text').length > 0){
    let deliveryArea = "";
    if (subjectPrefecture === undefined || subjectPrefecture == '') {
    } else {
      $.each(subjectPrefecture, function(key) {
        deliveryArea += key+'<br>';
      });
      $('.product__deliveryarea__text').html(deliveryArea);
    }
  }
  */
});